import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { site } from "@/data/site";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[var(--ns-text)] text-white mt-20"
        >
            <div className="container-ns py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="w-14 h-14 rounded-md bg-white p-1.5 flex items-center justify-center">
                            <img
                                src={site.logo}
                                alt="NS Tømrer og Ejendomsservice logo"
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <div className="font-display font-extrabold text-lg">
                            NS Tømrer og Ejendomsservice
                        </div>
                    </div>
                    <p className="text-white/70 text-sm leading-relaxed max-w-md">
                        Din lokale tømrer i Silkeborg og omegn. Jeg sætter en
                        ære i godt håndværk og ordentligt arbejde — både på
                        små og store opgaver. Skriv eller ring, så tager vi en
                        snak.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <div className="overline !text-white/60 mb-4">Sider</div>
                    <ul className="space-y-2.5 text-sm">
                        <li>
                            <Link
                                to="/"
                                className="text-white/80 hover:text-white transition"
                                data-testid="footer-link-home"
                            >
                                Forside
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/ydelser"
                                className="text-white/80 hover:text-white transition"
                                data-testid="footer-link-ydelser"
                            >
                                Ydelser
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/projekter"
                                className="text-white/80 hover:text-white transition"
                                data-testid="footer-link-projekter"
                            >
                                Projekter
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/om"
                                className="text-white/80 hover:text-white transition"
                                data-testid="footer-link-om"
                            >
                                Om os
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/kontakt"
                                className="text-white/80 hover:text-white transition"
                                data-testid="footer-link-kontakt"
                            >
                                Kontakt
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <div className="overline !text-white/60 mb-4">Kontakt</div>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <a
                                href={site.phoneHref}
                                data-testid="footer-phone"
                                className="flex items-center gap-3 text-white/80 hover:text-white transition group"
                            >
                                <span className="w-8 h-8 rounded-md bg-white/5 grid place-items-center group-hover:bg-[var(--ns-blue)] transition">
                                    <Phone className="w-4 h-4" />
                                </span>
                                {site.phone}
                            </a>
                        </li>
                        <li>
                            <a
                                href={site.emailHref}
                                data-testid="footer-email"
                                className="flex items-center gap-3 text-white/80 hover:text-white transition group"
                            >
                                <span className="w-8 h-8 rounded-md bg-white/5 grid place-items-center group-hover:bg-[var(--ns-blue)] transition">
                                    <Mail className="w-4 h-4" />
                                </span>
                                {site.email}
                            </a>
                        </li>
                        <li>
                            <a
                                href={site.facebookUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-facebook"
                                className="flex items-center gap-3 text-white/80 hover:text-white transition group"
                            >
                                <span className="w-8 h-8 rounded-md bg-white/5 grid place-items-center group-hover:bg-[var(--ns-blue)] transition">
                                    <Facebook className="w-4 h-4" />
                                </span>
                                Facebook
                            </a>
                        </li>
                        <li>
                            <a
                                href={site.instagramUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-instagram"
                                className="flex items-center gap-3 text-white/80 hover:text-white transition group"
                            >
                                <span className="w-8 h-8 rounded-md bg-white/5 grid place-items-center group-hover:bg-[var(--ns-blue)] transition">
                                    <Instagram className="w-4 h-4" />
                                </span>
                                Instagram
                            </a>
                        </li>
                        <li className="flex items-center gap-3 text-white/60">
                            <span className="w-8 h-8 rounded-md bg-white/5 grid place-items-center">
                                <MapPin className="w-4 h-4" />
                            </span>
                            Silkeborg · Midtjylland
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="container-ns py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
                    <div>
                        © {new Date().getFullYear()} NS Tømrer og
                        Ejendomsservice · v/ Nicklas Sørensen
                    </div>
                    <div>Lokal tømrer · Silkeborg</div>
                </div>
            </div>
        </footer>
    );
}
